import { Observable } from 'rxjs/Observable'
import { DataService } from 'core/data/service'

export class ModalAviseService extends DataService {

  constructor() {
    super()
  }

  aviseme(request) {
    const options = {
      method: 'POST',
      url: '/atendimento/aviseme',
      data: request
    }

    return Observable
              .fromPromise(super.request(options));
  }
}






// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-aviseme/modal-aviseme.service.js